// Single source of truth for the two build-time knobs this package needs:
// whether the banner renders at all, and where "Learn more" points. Both
// apply globally, the same for every division - to disable or redirect only
// one division, use @ahi/header instead, which supports per-site, runtime-
// editable content and rollout gating.
//
// Both are plain constants baked into the bundle at build time. There is
// deliberately no runtime fetch here, so there is nothing to keep
// available/CORS-enabled just to render (or not render) the banner. To
// change either value, edit this file and republish.

//  To change it (or the copy/colors in divisions.ts) after go-live, edit and
//  republish this package - there is deliberately no runtime content fetch
//  here, so there is nothing to keep available/CORS-enabled just to render the
//  banner. If a site needs a different destination it can override this
//  attribute-free package entirely by continuing to use @ahi/header, which does
//  support runtime, centrally-editable content.
export const LEARN_MORE_HREF = "https://arrowheadintermediaries.com/our-next-chapter/";

/**
 * Global kill switch. Default true. Set to false and republish to stop the
 * banner rendering anywhere, for any division, on every site running this
 * build - e.g. to pause the rollout without touching the embed snippet on
 * every consuming site. Fails closed and silently (no console output, no
 * DOM work) when off, same posture as @ahi/header's rollout.enabled kill
 * switch (packages/header/src/rollout.ts) - this is a deliberate
 * operational state, not a misconfiguration a site owner could fix.
 */
export const BANNER_ENABLED = true;
